import { Routes } from '@angular/router';
import { LoaPage } from './loa-page/loa-page';
import { NotFoundPage } from './not-found/not-found';

export const routes: Routes = [
  {
    path: 'sign/:token',
    component: LoaPage,
  },
  {
    path: '404',
    component: NotFoundPage,
  },
  {
    path: '**',
    redirectTo: '/404',
    pathMatch: 'full'
  }
];
